/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  TextField,
  styled,
  Button,
  Card,
  LinearProgress,
  CircularProgress,
  InputLabel,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  FormHelperText,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import colors from "assets/theme/base/colors";
// import closeImg from "assets/images/close_X.svg";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import MDAlert from "components/MDAlert";
import React, { useState } from "react";
import DataTable from "examples/Tables/DataTable";
import MDProgress from "components/MDProgress";
import Spinner from "components/MDSpinner";
import { useMaterialUIController } from "context";
import MDTypography from "components/MDTypography";
import { generateExcelTemplateService } from "../services/ParticipantService";

export function ParticipantUpload({
  open,
  handleClose,
  isFormModified,
  isDisabled,
  isAlert,
  errorAlert,
  spinner,
  getFieldValue,
  sourceTypes,
  carnetTypes,
  handleFieldChange,
  handleSubmit,
  handleEstablishConnection,
  setColumTableNative,
  columTableNative,
  columData,
  statusConexion,
  tableRows,
  loading,
  isFieldValid,
  handleAlert = () => { },
}) {

  let { white, black } = colors;

  black = black.main;
  white = white.main;

  // Obtener el estado del tema (modo oscuro/claro)
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const handleDownloadTemplate = async () => {
    try {
      const result = await generateExcelTemplateService();

      if (result.success) {
        const url = window.URL.createObjectURL(result.blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Plantilla_Participantes.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        handleAlert('success', 'Plantilla descargada correctamente');
      } else {
        handleAlert('fail', result.message || 'Error al generar la plantilla');
      }
    } catch (error) {
      handleAlert('fail', 'Error al descargar la plantilla');
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    maxWidth: "1100px",
    minWidth: "350px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
    maxHeight: "95vh",
  };

  const modalContentStyle = {
    padding: "20px",
    maxHeight: "80%", // Establece la altura máxima para el contenido del modal
    overflowY: "auto", // Agregar scroll vertical al contenido del modal
  };

  const content = {
    margin: "0",
    padding: "0",
    display: "grid",
    align: "center",
    width: "100%",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
  };
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const tableColumns = [
    { Header: "BD Nativa", accessor: "staticValue" },
    { Header: "BD Entrante", accessor: "select" },
    // Tus otras columnas aquí...
  ];

  let activeButtomSubmit = true;
  // const activeButtomSubmit = isFormModified === true && isFieldValid.EXCEL === true ? false : true;
  if (isFormModified === true) {
    activeButtomSubmit = true;
  } else {
    activeButtomSubmit = isFormModified === false && isFieldValid.EXCEL === false ? true : false;
  }

  return (
    <>
      {/* <Spinner loading={loading}></Spinner> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={style}>
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography id="modal-modal-title" component="h2">
              Nueva fuente de datos
            </Typography>
            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={handleClose}
            >
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <div style={{ maxHeight: "80%", overflowY: "auto" }}>
            <form onSubmit={handleSubmit}>
              <MDBox sx={content}>
                <Box>
                  <MDTypography>Tipo de fuente</MDTypography>
                  {/* <FormControl sx={{ minWidth: 80 }}>
                    <Select
                      labelId="labelId-select-tipo-de-fuente"
                      id="select-tipo-de-fuente"
                      value={getFieldValue("name")}
                      onChange={(e) => handleFieldChange("name", e.target.value)}
                      style={{ fontSize: "15px", padding: "10px" }}
                      displayEmpty
                    >
                      <MenuItem value={""}>Seleccione...</MenuItem>
                      <MenuItem key={"EXCEL"} value={"EXCEL"}>
                        {"EXCEL"}
                      </MenuItem>
                    </Select>
                    {!isFieldValid.name && (
                      <FormHelperText className="Mui-error">
                        Tipo de fuente requerida
                      </FormHelperText>
                    )}
                  </FormControl> */}
                  <MDInput
                    disabled={true}
                    sx={{
                      marginTop: "5px",
                      "& .MuiInputBase-root": {
                        backgroundColor: darkMode ? "#424242 !important" : "#f5f5f5 !important",
                        color: darkMode ? "#ffffff !important" : "#000000 !important",
                      },
                      "& .MuiInputBase-input": {
                        color: darkMode ? "#ffffff !important" : "#000000 !important",
                      }
                    }}
                    value={getFieldValue("name")}
                    onChange={(e) => handleFieldChange("name", e.target.value)}
                  />
                </Box>

                {getFieldValue("name") === "EXCEL" && (
                  <Box sx={{ marginRight: "20px" }}>
                    <MDTypography>Fuente: Archivo excel</MDTypography>
                    <>
                      <span>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <a
                            onClick={handleDownloadTemplate}
                            style={{
                              fontSize: "1.1rem",
                              cursor: "pointer",
                              textDecoration: "underline",
                              color: "#1976d2"
                            }}
                          >
                            Descargar plantilla
                          </a>
                          <a
                            onClick={handleDownloadTemplate}
                            style={{
                              marginLeft: "5px",
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                              color: "#1A73E8",
                              cursor: "pointer",
                            }}
                          >
                            <DownloadIcon />
                          </a>
                        </div>
                      </span>
                      <MDInput
                        style={{ marginTop: "5px" }}
                        label=""
                        type="file"
                        error={!isFieldValid.EXCEL}
                        helperText={
                          !isFieldValid.EXCEL ? "El archivo no es de extension excel" : ""
                        }
                        FormHelperTextProps={{
                          className: !isFieldValid.EXCEL ? "Mui-error" : "",
                        }}
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          handleFieldChange("source", selectedFile);
                        }}
                      ></MDInput>
                      {!getFieldValue("source") && (
                        <FormHelperText className="Mui-error">Fuente requerida</FormHelperText>
                      )}
                      <label
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100px",
                          display: "inline-block",
                        }}
                        title={getFieldValue("source") ? getFieldValue("source").name : ""}
                      >
                        {getFieldValue("source") ? getFieldValue("source").name : ""}
                      </label>
                    </>
                  </Box>
                )}
              </MDBox>
            </form>
          </div>
          <Divider variant="middle" />

          <MDBox
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
            m={-0.5}
            mb={-2}
          >
            <MDButton color="error" onClick={handleClose}>
              Cancelar
            </MDButton>
            <MDButton
              onClick={handleSubmit}
              disabled={activeButtomSubmit}
              type="submit"
              color="success"
            >
              Guardar
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </>
  );
}
